<!-- Dotted Background -->
<span
  role="presentation"
  class="absolute inset-0 -z-10 h-full w-full bg-background bg-[radial-gradient(hsla(36,20%,95%,0.06)_2px,transparent_1px)] [background-size:32px_32px]"
/>

<!-- Top Fade -->
<span
  role="presentation"
  class="absolute left-0 top-0 h-[254px] w-full bg-gradient-to-b from-background to-transparent"
/>

<!-- Bottom Fade -->
<span
  role="presentation"
  class="absolute bottom-0 left-0 h-[254px] w-full bg-gradient-to-t from-background to-transparent"
/>
